"use client"

import Image from "next/image";
import ReadMore from "./readMore";

import heelio from "../../../public/heelio-mini.svg";

import React, { useState } from "react";
import MagicButton from "./MagicButton";
import { useRouter } from 'next/navigation'


function BusinessSector() {

    const router = useRouter()

    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);
    const [isHovered5, setIsHovered5] = useState(false);
    const [isHovered6, setIsHovered6] = useState(false);


    return(

        <div id="use-case" className="flex justify-center items-center flex-col mb-10 pt-20 mt-20  mx-10 text-[#042040]">
        <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-center text-[#042040] mb-5 mx-5 relative">
          Vos enjeux, notre solution
          {/*<svg
                    className="rotate-180 absolute opacity-0 md:opacity-100 w-40 h-36 md:top-6 lg:top-8 md:-left-36 lg:-left-28"
                    width="52.804508mm"
                    height="111.94577mm"
                    viewBox="0 0 52.804508 111.94577"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    >
                    <path
                        style={{ fill: '#FED90F', stroke: 'none', strokeWidth: '0.215072' }}
                        d="m4.9024998,3.6343535 c2.64784,-0.513484 5.2758702,-0.961974 7.9576602,-1.254751 0.82663,-0.09024 2.29261,-0.257381 1.80173,-1.51015103 -0.54498,-1.390776 -4.10545,-0.273172 -5.2428802,-0.246105 -2.0526,0.04883 -3.96425,0.155936 -6.02201,0.01924 -0.80171,-0.05326 -1.70697,-0.04986 -2.23602,0.65782903 -0.68376001,0.91463 -0.35690001,2.756851 -0.34402001,3.839437 0.0367,3.086842 1.02631001,6.7776695 3.24534001,9.0136005 0.81936,0.825618 2.60884,2.277053 3.69156,1.001504 0.77729,-0.91569 -0.01,-2.158548 -0.20296,-3.132803 -0.58072,-2.9247195 -1.57556,-5.6067095 -2.6484,-8.3878055 m 5.8388002,2.16614 c -1.4612902,0.761613 0.0369,1.982835 0.8286,2.405129 3.50796,1.8710605 6.87644,4.0137795 9.89314,6.6124725 11.74508,10.11763 20.01439,24.505943 24.27281,39.358167 4.52641,15.78736 5.58047,34.43129 -7.49741,46.651263 -4.59243,4.29132 -10.65101,7.52365 -16.99047,7.95766 -1.25219,0.0858 -5.9856,-0.91685 -6.11959,0.87986 -0.10188,1.36614 2.37945,1.67993 3.32365,1.90748 3.64565,0.87813 7.79701,0.65102 11.39882,-0.34735 3.92915,-1.08913 7.58344,-3.11875 10.7536,-5.64757 C 61.30878,89.061577 53.41758,58.528457 42.68871,38.691077 40.69005,34.99528 38.50707,31.420569 36.15891,27.937479 31.34689,20.799112 25.2382,14.611707 18.23696,9.6263395 16.52615,8.4081285 14.70817,7.3561685 12.86016,6.3640635 12.25101,6.0370465 11.45899,5.8004885"
                    />
                </svg>*/}
        </h4>

        <p className="text-sm sm:text-lg md:text-xl mx-5 text-center mb-20">Quelques exemples d&apos;accompagnements par heelio ces dernières années</p>

        
        


        <div className="max-w-[1400px] text-sm md:text-md cursor-pointer flex flex-wrap justify-center items-start gap-10 text-[#042040] mb-10">
            <div 
                className="w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col"
                onMouseEnter={() => setIsHovered1(true)}
                onMouseLeave={() => setIsHovered1(false)}
                onClick={() => router.push("/use-case/Ecommerce")}
            >
                
                <div className="flex justify-start items-center gap-3 w-fit px-5 py-3 rounded-full border border-2 border-[#042040] text-left mb-10">
                    <Image src={heelio} alt='secteur' />
                    <p>E-Commerce B2C</p>
                </div>

                <p className="text-left pb-4 leading-8 grow text-lg font-semibold">Société e-commerce en forte croissance avec un CA &gt; 5m€.</p>
                <p className="text-left pb-4 leading-8 grow text-base font-semibold">➜ Construction du reporting financier et du Business plan</p>
                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered1}/>
                </div>
                
            </div>

            <div 
                className="w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col"
                onMouseEnter={() => setIsHovered2(true)}
                onMouseLeave={() => setIsHovered2(false)}
                onClick={() => router.push("/use-case/Saas")}
            >
                
                <div className="flex justify-start items-center gap-3 w-fit px-5 py-3 rounded-full border border-2 border-[#042040] text-left mb-10">
                    <Image src={heelio} alt='secteur'/>
                    <p>Marketplace B2B</p>
                </div>

                <p className="text-left pb-4 leading-8 grow text-lg font-semibold">Société&nbsp; 
                Marketplace BtoB avec un CA &gt; 15m€.</p>
                <p className="text-left pb-4 leading-8 grow text-base font-semibold">➜ Construction du reporting financier et du Business plan (+500k€ sur l’EBITDA et +5m€ sur le CA)</p>
                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered2}/>
                </div>
                
            </div>

            <div 
                className="w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col"
                onMouseEnter={() => setIsHovered4(true)}
                onMouseLeave={() => setIsHovered4(false)}
                onClick={() => router.push("/use-case/DigitalAgency")}
            >
                
                <div className="flex justify-start items-center gap-3 w-fit px-5 py-3 rounded-full border border-2 border-[#042040] text-left mb-10">
                    <Image src={heelio} alt='secteur'/>
                    <p>Agence digitale</p>
                </div>

                <p className="text-left pb-4 leading-8 grow text-lg font-semibold">Agence digitale avec un CA &gt; 1.2m€.</p>
                <p className="text-left pb-4 leading-8 grow text-base font-semibold">➜ Mise en place du reporting et du Business plan (+700k€ sur l’EBITDA)</p>

                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered4}/>
                </div>
                
            </div>
            

            <div 
                className="w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col cursor-pointer"
                onMouseEnter={() => setIsHovered5(true)}
                onMouseLeave={() => setIsHovered5(false)}  
                onClick={() => router.push("/use-case/SoftwareEditor")}  
            >
                
                <div className="flex justify-start items-center gap-3 w-fit px-5 py-3 rounded-full border border-2 border-[#042040] text-left mb-10">
                    <Image src={heelio} alt='secteur'/>
                    <p>Saas</p>
                </div>

                <p className="text-left pb-4 leading-8 grow text-lg font-semibold">Editeur de logiciel Saas avec un CA &gt; 2m€.</p>
                <p className="text-left pb-4 leading-8 grow text-base font-semibold">➜ Mise à jour du Business plan et analyse de la trésorerie (+50% de CA et passage en cash-flow
positif).</p>

                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered5}/>
                </div>
                
            </div>

            <div 
                className="w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col cursor-pointer"
                onMouseEnter={() => setIsHovered6(true)}
                onMouseLeave={() => setIsHovered6(false)}
                onClick={() => router.push("/use-case/EquipmentRentalB2B")}  
            >
                
                <div className="flex justify-start items-center gap-3 w-fit px-5 py-3 rounded-full border border-2 border-[#042040] text-left mb-10">
                    <Image src={heelio} alt='secteur'/>
                    <p>Location de matériel B2B</p>
                </div>

                <p className="text-left pb-4 leading-8 grow text-lg font-semibold">Société de location de matériel en leasing avec un CA &lt; 1m€.</p>
                <p className="text-left pb-4 leading-8 grow text-base font-semibold">➜ Mise en place du reporting financier et du Business plan (+1.1M€ de financements obtenus)</p>

                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered6}/>
                </div>
                
            </div>

            <div 
                className="cursor-pointer w-[350px] md:w-[400px] max-h-[400px] md:h-[400px] p-5 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col bg-[#042040]"
                onMouseEnter={() => setIsHovered3(true)}
                onMouseLeave={() => setIsHovered3(false)}
                onClick={() => router.push("/use-case")}  
            >
                
                <div className="text-white font-bold text-left pb-4 leading-8 grow text-3xl md:text-4xl lg:text-5xl flex justify-start items-center"><p>Découvrir<br></br> tous nos <br></br>cas clients</p></div>
                
                <div className="flex justify-end items-center gap-2">
                    <ReadMore hover={isHovered3}/>
                </div>
                
            </div>

            
        </div>

        <div className="my-10">
        <div className='flex justify-center items-center gap-5 sm:gap-10 mt-10 flex-col sm:flex-row'>
               
              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  <div className='absolute top-0 left-0 rounded-md bg-[#FED90F66] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                  
                  <div className="z-10 w-fit rounded-md px-3.5 py-2.5 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/decouverte"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Réserver votre démo
                      </a>
                  </div>
              </div>

              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  
                  <div className="z-10 w-fit py-1 border-b-2 border-[#FED90F33] hover:border-[#FED90F] relative transform translate-y-0 translate-x-0 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/consultation"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Prendre RDV avec un DAF*
                      </a>
                  </div>
              </div>

            </div>
            
            
            <p className='font-extralight text-xs md:text-sm mt-5 max-w-2/3 text-center'>*Consultation gratuite : conseil sur votre environnement et vos problématiques financières</p>
        </div>


        
        </div>
        
    )
}

export default BusinessSector;